import { call, put, takeLatest } from 'redux-saga/effects';

import API from '@sm/api';
import { axiosCall } from '@utils';
import {
  MARK_NOTIFICATIONS_PROCESSED,
  PULL_USER_NOTIFICATIONS,
  setUserNotificationsAction,
  setUserNotificationsLoadingAction
} from './action';

function* pullUserNotificationsSaga() {
  try {
    yield put(setUserNotificationsLoadingAction(true));
    const { data } = yield call(axiosCall.get, API.notifications.list);
    yield put(setUserNotificationsAction(data));
  } catch (error) {
    yield put(setUserNotificationsAction([]));
  } finally {
    yield put(setUserNotificationsLoadingAction(false));
  }
}

function* markNotificationsProcessedSaga({ notificationIds }) {
  try {
    yield put(setUserNotificationsLoadingAction(true));
    const { data } = yield call(axiosCall.patch, API.notifications.list, {
      notification_ids: notificationIds,
      mark_as_read: true
    });
    yield put(setUserNotificationsAction(data));
  } finally {
    yield put(setUserNotificationsLoadingAction(false));
  }
}

export function* notificationsSagaWatcher() {
  yield takeLatest(PULL_USER_NOTIFICATIONS, pullUserNotificationsSaga);
  yield takeLatest(MARK_NOTIFICATIONS_PROCESSED, markNotificationsProcessedSaga);
}
